import GameObject from '../../../GameObject/GameObject';
import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import { StartAnimation } from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import { CARD_STACK_OFFSET } from '../../../Constants/InGame';

interface ICardPlusFiveMeta {
    targetCards: BaseCard[];
    stackContainer: GameObject;
}

export class CardPlusOne extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: ICardPlusFiveMeta
    ): IterableIterator<number> {
        // Set position of all cards first to fix stack counter.
        for (let card of meta.targetCards) {
            meta.stackContainer.addChild(card);
            const transform = card.getComponent(TransformComponent);
            transform.position.set(-200, 200);
        }

        for (let i = 0; i < meta.targetCards.length; i++) {
            const card = meta.targetCards[i];
            const transform = card.getComponent(TransformComponent);
            card.getComponent(Renderable).visible = true;
            StartAnimation(card, 'CardSlide', {
                x: CARD_STACK_OFFSET,
                y: 0,
            }).on(AnimationClipEvent.COMPLETE, () => {
                transform.rotation = 0;
                this.emit('PlusOneCardAdded', card);
            });

            // Delay between each card sliding in.
            yield* delay(100);
        }

        yield* delay(200);
    }
}
